export default __webpack_public_path__ + "static/media/gauge.24e519ae.png";